import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription, filter } from 'rxjs';

import { SiteHeaderComponent } from './shared/layout/site-header/site-header.component';
import { SiteFooterComponent } from './shared/layout/site-footer/site-footer.component';
import { LoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component';
import { AuthService } from './shared/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],

    standalone: true,

    imports: [
        CommonModule,
        RouterOutlet,
        SiteHeaderComponent,
        SiteFooterComponent,
        LoadingOverlayComponent,
    ],
})
export class AppComponent implements OnInit, OnDestroy {
    private expirySub: Subscription;
    public tokenExpirySeconds: number = -1;
    public isHealthRoute = false;

    constructor(
        private titleService: Title,
        private authService: AuthService,
        private router: Router) {
            this.expirySub = this.authService.tokenExpiryWarning$.subscribe(seconds => {
                this.tokenExpirySeconds = seconds;
            });
            this.router.events.pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd)
            ).subscribe(e => {
                this.isHealthRoute = e.urlAfterRedirects === '/health';
            });
        }

    ngOnInit(): void {
      this.titleService.setTitle('Marsh Credi-link');
      this.updateFavicon();
    }

    updateFavicon(): void {
        const link: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');

        if (link) {
            link.href = '../../assets/images/Marsh_vertical_white_logo.png';
        }
    }

    ngOnDestroy() {
        this.expirySub.unsubscribe();
    }
}